'use client';

// todo: could use a better name. it's like the "medium" sized view of an object and was pulled out of ObjectViewer
import PropTypes from 'prop-types';
import NoImage from 'assets/icons/no-image.svg';
import styles from './artwork-basics.module.scss';
import SanityImage from '@sanity-image';
import MarkdownParser from 'components/rich-text/markdown-parser';
import RichText from 'components/rich-text';

// note: ironically we're probably going to keep this modal for archival labels, but move away from using it for objects
const StudentArtworkBasics = ({ artwork }) => {
	return (
		<div className={styles.content}>
			<div
				className={
					styles.imageWrapper +
					(!artwork?.image ? ' ' + styles.imageWrapperNoImage : '')
				}
			>
				{artwork?.image ? (
					<>
						<SanityImage image={artwork.image} />
					</>
				) : (
					<div className={styles.noImageContainer}>
						<NoImage className={styles.noImageSvg} />
					</div>
				)}
			</div>
			<div className={styles.text}>
				<div className={styles.caption}>
					<h2 className={`serif ${styles.title}`}>
						<MarkdownParser>{artwork?.title}</MarkdownParser>
					</h2>
					<div className={styles.attribution}>{artwork.student}</div>
					<div className={styles.materials}>
						{!!artwork.grade && <div>Grade: {artwork.grade}</div>}
						{!!artwork.materials && <div>Materials: {artwork.materials}</div>}
						{!!artwork.school && <div>School: {artwork.school}</div>}
						{!!artwork.teacher && <div>Teacher: {artwork.teacher}</div>}
					</div>
					{!!artwork.studentStatement && (
						<div className={styles.statement}>
							<div className={styles.statementHeader}>STUDENT:</div>
							<RichText value={artwork.studentStatement} />
						</div>
					)}
					{!!artwork.teacherStatement && (
						<div className={styles.statement}>
							<div className={styles.statementHeader}>TEACHER:</div>
							<RichText value={artwork.teacherStatement} />
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

StudentArtworkBasics.propTypes = {
	artwork: PropTypes.object.isRequired,
};

export default StudentArtworkBasics;
